import { MailingAddressResponse } from '../../models/mailing-address-response.model';
import { Observable, of } from 'rxjs';

export class PolicyServiceStub {
    getBranchesList() {
        return of([]);
    }

    setElectronicMarkByPolicyPeriodId(): Observable<any> {
        return of(null);
    }

    getElectronicMarkByPolicyPeriodId(policyPeriodId: string): Observable<{ electronicDocumentsMark: boolean }> {
        return of({ electronicDocumentsMark: true });
    }

    primaryContactData() { }

    getPaymentInfo(arg1: string, arg2: string) { return of({}); }

    getSimplePolicyHeader(arg: string) { return of({}); }

    getMailingAddress(policyNumber: string): Observable<MailingAddressResponse> {
        return of({
            mailingAddress: {
                active: true,
                addressLine1: 'Entre rios',
                addressLine2: '',
                addressLine3: '',
                addressType: {
                    code: '',
                    description: ''
                },
                block: '',
                coordinates: '',
                country: {
                    code: 'ar',
                    description: 'Argentina'
                },
                county: '',
                description: '',
                displayText: '',
                policyAddress: '',
                primaryAddress: '',
                publicId: '',
                state: {
                    code: '',
                    description: ''
                },
                streetNumber: '1543',
                postalCode: '2000',
                city: 'Rosario'
            }
        });
    }

    getPolicyNumberByJobNumber(): string {
        return '01-01-01-30000000';
    }

    deleteDraft(): Observable<void> {
        return of(null);
    }
}
